import { Heading } from "@chakra-ui/react";
import React from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { AiOutlineArrowLeft } from "react-icons/ai";

export const projectdetails = [
  {
    title: "wrapUp",
    desc: "Wrapup is a project management company. It lets users set timelines, divide tasks among team collaborators, and remind them of tasks and deadlines. SOLO project.",
    tech: ["REACT Js", "Chakra UI", "JavaScript", "Context API"],
    github: "https://github.com/DishaGup/pink-pot-9002",
    deployed: "https://wrap-up.vercel.app/",
    image:
      "https://camo.githubusercontent.com/b028209bbe529c100356331eb038ca8e39ee5f393b3842f72d277299777e08d1/68747470733a2f2f6d617361692d636f757273652e73332e61702d736f7574682d312e616d617a6f6e6177732e636f6d2f656469746f722f75706c6f6164732f323032332d30322d32372f53637265656e73686f742532302532383537322532395f3133393136362e706e67",
  },
  {
    title: "Trendify",
    desc: "Trendify is an Scalable e-commerce website for all Products. An Collaborative project. Created Backened and also worked upon Product Page includes sorting and filtering.",
    tech: [
      "Node Js",
      "Mongo DB",
      "REACT Js",
      "Chakra UI",
      "Redux",
      "JWT",
      "Express Js",
    ],
    github: "https://github.com/DishaGup/eminent-art-8078",
    deployed: "https://trendify-omega.vercel.app/",
    image:
      "https://github.com/DishaGup/eminent-art-8078/assets/115460391/8bc6dfe0-bd22-4221-b483-b2092808f4b9",
  },
  {
    title: "Health Cube",
    desc: "HealthCube is an e-commerce website of Medicines. An Collaborative project built and executed in 5 days.",
    tech: ["MERN", "Chakra UI", "Redux", "JWT"],
    github: "https://github.com/DishaGup/subdued-stocking-2928",
    deployed: "https://healthcube-bisht1418.vercel.app/",
    image:
      "https://github.com/Shanky43/subdued-stocking-2928/blob/main/frontend/src/Assests/HomePage%20Image.png?raw=true",
  },
  {
    title: "homeDecor",
    desc: "Home Decor is a online-e-commerce website for customised furnitures. An Collaborative project built and executed in 5 days.",
    tech: ["MERN", "Chakra UI", "Redux", "JWT"],
    github: "https://github.com/DishaGup/eminent-trucks-727",
    deployed: "https://extraordinary-tartufo-1cb77e.netlify.app/",
    image:
      "https://github.com/DishaGup/eminent-trucks-727/raw/main/images/addtocart.png",
  },
  {
    title: "Story Generator",
    desc: "This is a frontend project built with React. It utilizes the OpenAI API to generate humorous stories based on provided keywords. The generated stories are displayed on the frontend.",
    tech: ["Python", "Open AI", "Flask", "HTML5", "CSS3"],
    github: "https://github.com/DishaGup/story-generator",
    deployed: "https://story-khaki-six.vercel.app/",
    image:
      "https://user-images.githubusercontent.com/115460391/251097537-8fe33048-9620-4b82-9711-d6d927219c50.png",
  },
  {
    title: "Logistics Management System",
    desc: "This backend repository contains the server code for the Logistics Management System. It's built using the MERN stack and provides APIs for managing items, customers, delivery vehicles, and orders.",
    tech: ["MERN", "Morgan", "JWT", "Redux"],
    github: "https://github.com/DishaGup/track-order",
    deployed: "",
    image:
      "https://user-images.githubusercontent.com/115460391/263009456-d85ee05d-80fc-4c47-8152-fcc4b1e26396.png",
  },
];

export const microproject = [
  {
    title: "Delhi Munchies: The Canteen",
    desc: "This command-line application is designed to manage the snack inventory of the canteen and keep track of sales. It allows canteen staff to add, remove, and update snacks in the inventory, as well as record sales.",
    tech: ["Python3", "Open AI", "CLI"],
    github: "https://github.com/DishaGup/Delhi-Munchies",
    deployed: "",
    image:
      "https://code.visualstudio.com/assets/docs/editor/command-line/tunnel-help.png",
  },

  {
    title: "Recipe Queen ",
    desc: "This project is a recipe viewing website that allows users to discover and view various recipes. The website provides a user-friendly interface to search, filter, and explore recipes from different cuisines and diet types. Users can also bookmark their favorite recipes for future reference.",
    tech: ["MERN", "API Integration", "JWT", "Redux"],
    github: "https://github.com/DishaGup/recipe-queen",
    deployed: "",
    image:
      "https://user-images.githubusercontent.com/115460391/262252117-3280a71e-83e8-4e35-846b-56fe7025ce41.png",
  },
  {
    title: "TastyBites App - Chatbot",
    desc: "The heart of the application lies in Flask and Python, which were employed to create key features such as menu management, order processing, and real-time updates. ",
    tech: ["Python3", "Open AI", "Flask", "Chatbot", "Socket IO"],
    github: "https://github.com/DishaGup/tasty-bites-fullstack",
    deployed: "",
    image:
      "https://user-images.githubusercontent.com/115460391/261339319-5bead290-f9a1-4a40-8763-6b7d9ade8a47.png",
  },
  {
    title: "Kanban Board",
    desc: "Kanban Board web application designed to enhance task management and workflow organization for individuals or teams. The Kanban methodology emphasizes visualizing work, limiting work in progress, and optimizing overall productivity",
    tech: ["MERN", "Chakra UI", "Redux", "JWT"],
    github: "https://github.com/DishaGup/kanban-board",
    deployed: "",
    image:
      "https://user-images.githubusercontent.com/115460391/251439867-57c4f472-5a16-458b-a8bc-74952f713620.png",
  },
  {
    title: "Live Crypto Market",
    desc: "Live Crypto Market: Website providing live stock market data to users. Real-time information about stocks and crypto.",
    tech: ["MERN", "Chakra UI", "Redux", "JWT"],
    github: "https://github.com/DishaGup/pink_purple_palace",
    deployed: "",
    image:
      "https://user-images.githubusercontent.com/115460391/250889830-e713ae0f-376c-43ec-8b7c-a229a71d04eb.png",
  },
  {
    title: "Rock Paper & Scissors Game",
    desc: "Rock Paper & Scissors Game: Simple web-based game built using Flask and JavaScript. Choose your move and play!",
    tech: ["Python", "Open AI", "Flask", "CLI"],
    github: "https://github.com/DishaGup/rock-paper-scissors",
    deployed: "",
    image:
      "https://masai-school.notion.site/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2Fccdc2380-d5df-4570-90c7-bb9f10537943%2FUntitled.png?id=d11273bb-7fd0-4848-b1d6-ce189677c398&table=block&spaceId=ff94b4dd-cb13-4ede-8019-d6a8215bf3d5&width=2000&userId=&cache=v2",
  },
];

const ProjectNew = () => {
  const items = projectdetails.map((el, i) => <ProjectCard {...el} />);
  const itemsicro = microproject.map((el, i) => <ProjectCard {...el} />);

  return (
    <section className="section feature" id="projects">
      <div className="container">
        <h2 className="headline headline-2 section-title">
          {" "}
          My recent <span className="span">Projects</span>
        </h2>
        <p className="section-text">checkout my recent works</p>
        {/* <ul className="feature-list"> */}
        <AliceCarousel
          items={items}
          responsive={{
            0: { items: 1 },
            768: { items: 2 },
            1024: { items: 2 },
          }}
          disableButtonsControls
          autoPlayInterval={4000}
          autoPlay
          infinite
          mouseTracking
        />{" "}
        <br />
        <AliceCarousel
          items={itemsicro}
          responsive={{
            0: { items: 1 },
            768: { items: 2 },
            1024: { items: 2 },
          }}
          disableButtonsControls
          autoPlayInterval={4000}
          autoPlay
          infinite
          mouseTracking
        />{" "}
        {/* </ul> */}
      </div>
    </section>
  );
};

export default ProjectNew;

const ProjectCard = ({ image, title, deployed, github, tech, desc }) => {
  return (
    <li style={{ padding: "10px", margin: "5px 8px", cursor: "grab " }}>
      <div className="card feature-card">
        <figure
          className="card-banner img-holder"
          style={{ "--width": 1602, "--height": 903 }}
        >
          <img
            src={image}
            width="1602"
            height="903"
            alt={title}
            className="img-cover"
          />
        </figure>

        <div className="card-content">
          <div className="card-wrapper">
            <div className="card-tag wrap">
              {tech.map((el, index) => (
                <span className="span hover-2">{el}</span>
              ))}
            </div>
          </div>

          <Heading
            mb="10px"
            color="#59c378"
            fontSize={"24px"}
            fontWeight={"600"}
            lineHeight={".9cm"}
            position="relative"
          >
            {title}
            <span className="underline"></span>
          </Heading>
          <h3 className="card-desc">
            <p className="card-title" style={{ fontSize: "15px" }}>
              {desc}
            </p>
          </h3>

          <div
            className="card-wrapper"
            style={{ width: "80%", margin: "25px auto" }}
          >
            <div className="profile-card">
              {deployed ? (
                <a href={deployed} className="card-btn" target="_blank">
                  <img
                    width="60"
                    height="60"
                    src="https://img.icons8.com/external-bearicons-gradient-bearicons/64/external-Live-social-media-bearicons-gradient-bearicons.png"
                    alt="external-Live-social-media-bearicons-gradient-bearicons"
                  />{" "}
                </a>
              ) : (
                <span style={{ textTransform: "uppercase" }}>Run backend</span>
              )}
            </div>

            <a href={github} className="card-btn" target="_blank">
              <img
                width="60"
                height="60"
                src="https://img.icons8.com/nolan/128/github.png"
                alt="github"
              />
            </a>
          </div>
        </div>
      </div>
    </li>
  );
};

const CustomLeftArrow = ({ onClick }) => (
  <div className="custom-arrow custom-arrow-left" onClick={onClick}>
    <AiOutlineArrowLeft />
  </div>
);

const CustomRightArrow = ({ onClick }) => (
  <div className="custom-arrow custom-arrow-right" onClick={onClick}>
    &gt; {/* Example: Use the greater-than symbol as an arrow */}
  </div>
);
